import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

const PartnerGymCourseHistoryInfoView = (props) => {
  const { data } = props;

  const { t, isEng } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [state, setState] = useState(t('memberDetail.statusReserved'));

  useEffect(() => {
    if (data.status === 0) {
      if (moment(data.classDate.split('T')[0] + "T" + data.classTime.split('-')[0] + ':00').isAfter(moment())) {
        setState(t('memberDetail.statusReserved'));
      }
      else {
        setState(t('memberDetail.statusAbsent'));
      }
    }
    else if (data.status === 1) {
      setState(t('memberDetail.statusAttended'));
    }
    else if (data.status === 2) {
      setState(t('memberDetail.statusLate'));
    }
    else if (data.status === 3) {
      setState(t('memberDetail.statusAbsent'));
    }
  }, [data])

  return (
    <TopLevelWrapper>
      <ComponentWrapper isDark={isDark}>
        <Table>
          <Body>
            <Tr style={{ width: '89px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '80px' }}>
                  <Text>{isEng ? moment(data.classDate).format(t('partnerGym.history.dateFormat')) : data.classDate.replaceAll('-', '.').slice(2, 10)}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '244px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '244px' }}>
                  <Text>{{ '일반방문': t('memberDetail.dataGeneralVisit'), '일반 방문': t('memberDetail.dataGeneralVisit') }[data.lessonName] || data.lessonName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '87px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '58px' }}>
                  <Text>{data.classTime.slice(0, 5)}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '80px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '80px' }}>
                  <Text>{{ '없음': t('memberDetail.dataNone') }[data.teacherName] || data.teacherName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '185px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '129px' }}>
                  <Text>{data.memberShipName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '82px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '14px' }}>
                  <Text>{data.deduction}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '180px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '160px' }}>
                  <Text>{state}</Text>
                </TextWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </ComponentWrapper>
    </TopLevelWrapper>
  )
};

export default PartnerGymCourseHistoryInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 1018px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 50px;

  background: ${props => props.theme.subBackground};

  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 30px;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;
